<template>
  <span>
    <!-- 
      // Following commented because - admin end not going to translated - also default english not working
     vue-cal :locale="vue_cal_locale" 
    -->
    <vue-cal
      class="vuecal--blue-theme"
      style="align-self: stretch;"
      v-if="events != null"
      default-view="month"
      hide-view-selector
      :events="events"
      :disable-views="['years', 'year', 'week', 'day']"
      :time="false"
      :min-date="cal_min_date"
      :max-date="cal_max_date"
      :events-on-month-view="true"
      @cell-click="
        cal_cell_trigger_show_edit_date_availability('cell-click', $event)
      "
      :on-event-click="cal_event_trigger_show_edit_date_availability"
      @view-change="process_calendar_month_move_event"
      ref="vuecal"
    >
    </vue-cal>

    <div
      v-if="events == null && (show_expired_msg || show_error_unable_fetch)"
      style="height:100%"
    >
      <h3 v-if="show_expired_msg" class="error_in_popup">
        This event type does not have any active or future schedule to
        customise.<br />
        Please check the date range of the event type.
      </h3>
      <h3 v-else-if="show_error_unable_fetch" class="error_in_popup">
        Unable to fetch the schedule. If you think this is an error, please
        <a href="https://wpcal.io/support/?utm_source=wpcal_plugin&utm_medium="
          >contact support</a
        >.
      </h3>
    </div>

    <div
      v-show="show_edit_date_availability_popup"
      id="edit_date_availability"
      style="z-index:10000; width: 360px;"
      class="popper-cont"
    >
      <div data-popper-arrow class="popper_arrow"></div>
      <div
        class="mbox bg-light shadow edit-availability"
        v-show="show_edit_date_availability"
      >
        <div class="txt-h4 bold center mb20 mt10">
          {{ T__("Edit Availability") }}
        </div>
        <div
          v-if="
            current_customizing_availability_date_details &&
              current_customizing_availability_date_details.is_available == 0
          "
        >
          <div class="unavailable">{{ T__("Unavailable") }}</div>
          <button
            class="wpc-btn secondary sm mt10 center"
            :disabled="!current_date_popup_action_btns_is_enabled"
            @click="
              update_customizes_date_availability(
                'this_day_available_use_previous_periods'
              )
            "
          >
            {{
              Tsprintf(
                /* translators: %s: date */
                T__("Set as available on %s"),
                apply_to_this_date
              )
            }}
          </button>
        </div>
        <TimeRange1ToN
          v-model="current_customizing_availability_date_details.periods"
          v-if="current_customizing_availability_date_details"
          hide_add_period_on_no_periods="1"
        ></TimeRange1ToN>

        <button
          class="wpc-btn secondary sm mt10 center"
          :disabled="!current_date_popup_action_btns_is_enabled"
          @click="update_customizes_date_availability('this_day_unavailable')"
          v-if="
            current_customizing_availability_date_details &&
              current_customizing_availability_date_details.is_available == 1
          "
        >
          {{
            Tsprintf(
              /* translators: %s: date */
              T__("Set as unavailable on %s"),
              apply_to_this_date
            )
          }}
        </button>
        <span v-if="current_customizing_availability_date_details">
          <button
            class="wpc-btn primary md mt20 full-width"
            :disabled="!current_date_popup_action_btns_is_enabled"
            @click="update_customizes_date_availability('this_date_only')"
          >
            {{
              Tsprintf(
                /* translators: %s: date */
                T__("Apply to %s only"),
                apply_to_this_date
              )
            }}
          </button>
          <button
            class="wpc-btn primary md mt10 full-width"
            :disabled="!current_date_popup_action_btns_is_enabled"
            @click="
              update_customizes_date_availability('this_day_from_this_date')
            "
          >
            {{
              Tsprintf(
                /* translators: 1: weekday 2: date */
                T__("Apply to all %1$s from %2$s"),
                apply_to_all_days,
                apply_from_this_date
              )
            }}
          </button>
          <button
            class="wpc-btn secondary-link md mt10 center"
            :disabled="!current_date_popup_action_btns_is_enabled"
            @click="show_apply_to_multiple_dates_by_date"
          >
            {{ T__("Apply to multiple...") }}
          </button>
        </span>
        <button
          class="wpc-btn tert-link sm mt20 center"
          @click="close_edit_date_availability_popup_by_date"
        >
          {{ T__("Cancel") }}
        </button>
      </div>

      <div
        class="mbox bg-light shadow edit-availability"
        id="apply_to_multiple_dates"
        v-show="show_apply_to_multiple_dates"
        style="z-index:10001;"
      >
        <div class="txt-h4 center mb20 mt10">
          <div
            class="icon-back"
            @click="back_to_show_edit_date_availability"
          ></div>
          {{ T__("Apply to multiple...") }}
        </div>
        <ul class="selector apply-multiple inline time mt10 mb10">
          <li>
            <input
              type="radio"
              id="multiple-dates"
              name="apply_multiple_dates_days"
              value="dates"
              v-model="popup_edit_availability_form.apply_multiple_dates_days"
            />
            <label for="multiple-dates">{{ T__("dates") }}</label>
          </li>
          <li>
            <input
              type="radio"
              id="repeating-days"
              name="apply_multiple_dates_days"
              value="days"
              v-model="popup_edit_availability_form.apply_multiple_dates_days"
            />
            <label for="repeating-days">{{
              T__("repeating days of the week")
            }}</label>
          </li>
        </ul>

        <div
          v-if="
            popup_edit_availability_form.apply_multiple_dates_days === 'dates'
          "
        >
          <v-date-picker
            mode="multiple"
            is-inline
            :locale="this.$store.getters.get_site_locale_intl"
            @dayclick="log"
            style="width: 100%;"
            value="current_customizing_availability_date"
            v-model="popup_edit_availability_form.selected_dates"
            :min-date="apply_multipe_date_picker_min_date"
            :max-date="apply_multipe_date_picker_max_date"
            ref="multiple_dates_picker"
          />
          <div
            v-show="dates_selected_meta_txt"
            style="text-align:center;padding-top:5px;"
          >
            {{
              Tsprintf(
                /* translators: 1: int */
                T__("%1$s selected"),
                dates_selected_meta_txt
              )
            }}
            &bull;
            <a @click="popup_edit_availability_form.selected_dates = []">{{
              T__("Clear")
            }}</a>
          </div>
          <button
            class="wpc-btn primary md mt20 full-width"
            :disabled="!current_date_popup_action_btns_is_enabled"
            @click="
              update_customizes_date_availability('apply_to_selected_dates')
            "
          >
            {{ T__("Apply") }}
          </button>
        </div>
        <div
          v-if="
            popup_edit_availability_form.apply_multiple_dates_days === 'days'
          "
        >
          <WeekDaysSelector
            v-model="popup_edit_availability_form.apply_multiple_days"
          />
          <button
            class="wpc-btn primary md mt20 full-width"
            :disabled="!current_date_popup_action_btns_is_enabled"
            @click="
              update_customizes_date_availability('apply_to_selected_days')
            "
          >
            Apply to selected day(s) from {{ apply_from_this_date }}
          </button>
        </div>
        <button
          class="wpc-btn tert-link sm mt20 center"
          @click="back_to_show_edit_date_availability"
        >
          {{ T__("Cancel") }}
        </button>
      </div>
    </div>
    <div style="padding:10px;margin-top: -35px;">
      <AdminInfoLine
        info_slug="timings_in_timezone"
        :timezone="timezone"
        style="margin:0;width:max-content;"
      />
      <a
        href="https://help.wpcal.io/en/article/how-to-customise-availability-for-event-type-one-or-more-days-qfc8ez/?utm_source=wpcal_plugin&utm_medium=contextual"
        target="_blank"
        style="float:right;margin-top:-25px;"
        >Learn more about advance customization</a
      >
    </div>
  </span>
</template>

<script>
import TimeRange1ToN from "@/components/form_elements/TimeRange1ToN.vue";
import WeekDaysSelector from "@/components/form_elements/WeekDaysSelector.vue";

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import { createPopper } from "@popperjs/core";

import { format } from "date-fns";
import { map, cloneDeep } from "lodash-es";

import axios from "axios";

export default {
  components: {
    VueCal,
    TimeRange1ToN,
    WeekDaysSelector
  },
  props: {
    timezone: {
      type: String
    }
  },
  data() {
    return {
      service_availability_data: null,
      events: null,
      show_edit_date_availability_popup: false,
      show_edit_date_availability: false,
      show_apply_to_multiple_dates: false,
      current_customizing_availability_date: null,
      current_customizing_availability_date_formatted: null,
      current_customizing_availability_date_details: null,
      popup_instance: null,
      popup_edit_availability_form: {
        apply_multiple_dates_days: "dates",
        apply_multiple_days: [],
        selected_dates: []
      },
      can_load_availability_for_calendar_month_move_event: false,
      current_calendar_month: {},
      current_date_popup_action_btns_is_enabled: true,
      show_expired_msg: false,
      show_error_unable_fetch: false
    };
  },
  computed: {
    cal_min_date() {
      if (
        !this.service_availability_data ||
        !this.service_availability_data.availability_date_ranges ||
        !this.service_availability_data.availability_date_ranges
          .current_available_from_date
      ) {
        return "";
      }
      return this.service_availability_data.availability_date_ranges
        .current_available_from_date;
    },
    cal_max_date() {
      if (
        !this.service_availability_data ||
        !this.service_availability_data.availability_date_ranges ||
        !this.service_availability_data.availability_date_ranges
          .current_available_to_date
      ) {
        return "";
      }
      return this.service_availability_data.availability_date_ranges
        .current_available_to_date;
    },
    apply_multipe_date_picker_min_date() {
      //to restrict selectable dates
      if (
        !this.service_availability_data ||
        !this.service_availability_data.availability_date_ranges ||
        !this.service_availability_data.availability_date_ranges
          .current_available_from_date
      ) {
        return undefined;
      }
      return this.service_availability_data.availability_date_ranges
        .current_available_from_date;
    },
    apply_multipe_date_picker_max_date() {
      //to restrict selectable dates
      if (
        !this.service_availability_data ||
        !this.service_availability_data.availability_date_ranges ||
        !this.service_availability_data.availability_date_ranges
          .current_available_to_date
      ) {
        return undefined;
      }
      return this.service_availability_data.availability_date_ranges
        .current_available_to_date;
    },
    apply_to_this_date() {
      if (
        !this.current_customizing_availability_date ||
        typeof this.current_customizing_availability_date.getMonth !==
          "function"
      ) {
        return "";
      }
      return format(this.current_customizing_availability_date, "d MMM");
    },
    apply_from_this_date() {
      return this.apply_to_this_date;
    },
    apply_to_all_days() {
      if (
        !this.current_customizing_availability_date ||
        typeof this.current_customizing_availability_date.getMonth !==
          "function"
      ) {
        return "";
      }
      return format(this.current_customizing_availability_date, "EEEE") + "s";
    },
    dates_selected_meta_txt() {
      let len = this.popup_edit_availability_form.selected_dates.length;
      let txt = "";
      if (len) {
        txt = this.Tsprintf(
          /* translators: %s: int */
          this.T_n("%s day", "%s days", len),
          len
        );
      }
      return txt;
    }
    // Following commented because - admin end not going to translated - also default english not working
    /*
    vue_cal_locale() {
      let site_locale = this.$store.getters.get_site_locale_intl;
      site_locale = site_locale.toLowerCase();

      let default_locale = "";

      let available_locale = [
        "ar",
        "bg",
        "bn",
        "bs",
        "ca",
        "cs",
        "da",
        "de",
        "el",
        "es",
        "fa",
        "fr",
        "he",
        "hr",
        "hu",
        "id",
        "is",
        "it",
        "ja",
        "ka",
        "ko",
        "lt",
        "nl",
        "no",
        "pl",
        "pt-br",
        "ro",
        "ru",
        "sk",
        "sl",
        "sr",
        "sv",
        "tr",
        "uk",
        "vi",
        "zh-cn",
        "zh-hk"
      ];

      if (available_locale.indexOf(site_locale) !== -1) {
        return site_locale;
      }
      let site_locale_parts = site_locale.split("-");
      if (available_locale.indexOf(site_locale_parts[0]) !== -1) {
        return site_locale_parts[0];
      }
      return default_locale;
    }*/
  },
  mounted() {
    // Following commented because - admin end not going to translated - also default english not working
    // if (this.vue_cal_locale) {
    //   require("vue-cal/dist/i18n/" + this.vue_cal_locale + ".js");
    // }
    this.show_service_availability_cal();
  },
  methods: {
    show_service_availability_cal() {
      let action = "edit_service_availability";
      let wpcal_request = {};
      wpcal_request[action] = {
        service_id: this.$route.params.service_id
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          // response = wpcal_clean_and_parse_json_response(response);
          //console.log(response);
          //alert(response.data.status);
          if (
            response.data[action] &&
            response.data[action].status == "success"
          ) {
            this.service_availability_data =
              response.data[action].service_availability_data;
            this.events =
              response.data[
                action
              ].service_availability_data.dates_availability_for_cal;
            setTimeout(() => {
              if (this.$refs.vuecal) {
                this.$refs.vuecal.switchView(
                  "month",
                  this.date_parse(this.cal_min_date)
                ); //switch over to first available date
              }
              this.can_load_availability_for_calendar_month_move_event = true; //hackish fix to avoid inital calendar view change event and one after initial load
            }, 100);
          }
          if (
            response.data[action] &&
            response.data[action].status == "error"
          ) {
            if (
              response.data[action].error &&
              response.data[action].error == "expired"
            ) {
              this.show_expired_msg = true;
              this.show_error_unable_fetch = false;
            } else {
              this.show_expired_msg = false;
              this.show_error_unable_fetch = true;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    process_calendar_month_move_event(event_values) {
      let month = format(event_values.startDate, "LL");
      let year = format(event_values.startDate, "yyyy");

      this.current_calendar_month = { month: month, year: year };
      this.load_service_availability_by_calendar_view(
        this.current_calendar_month
      );
      this.close_edit_date_availability_popup_by_date();
    },
    load_service_availability_by_calendar_view(current_calendar_month) {
      if (
        !this.can_load_availability_for_calendar_month_move_event ||
        !current_calendar_month ||
        typeof current_calendar_month !== "object" ||
        !current_calendar_month.hasOwnProperty("month")
      ) {
        return;
      }

      let action = "edit_service_availability_by_month";
      let wpcal_request = {};
      wpcal_request[action] = {
        service_id: this.$route.params.service_id,
        current_month_view: current_calendar_month
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          // response = wpcal_clean_and_parse_json_response(response);
          //console.log(response);
          //alert(response.data.status);
          this.handle_load_service_availability_by_calendar_view_response(
            response
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    handle_load_service_availability_by_calendar_view_response(response) {
      let action = "edit_service_availability_by_month";
      if (
        response.data[action] &&
        response.data[action].status == "success" &&
        response.data[action].service_availability_data &&
        response.data[action].service_availability_data
          .dates_availability_for_cal
      ) {
        this.service_availability_data =
          response.data[action].service_availability_data;

        this.events =
          response.data[
            action
          ].service_availability_data.dates_availability_for_cal;
      }
    },
    // eslint-disable-next-line no-unused-vars
    cal_event_trigger_show_edit_date_availability(event, e) {
      //console.log(event, e);
      let formatted_date = format(event.startDate, "yyyy-MM-dd");
      this.current_customizing_availability_date = event.startDate;
      this.current_customizing_availability_date_formatted = formatted_date;
      setTimeout(() => {
        //setTimeout used  const element = document.querySelector(".vuecal__cell--selected"); will have right element
        this.show_edit_date_availability_popup_by_date();
      }, 10);
    },
    cal_cell_trigger_show_edit_date_availability(name, event) {
      //console.log(name, event);
      if (!event) {
        //unexpectedly this calls twice per click, 2nd time null coming
        return;
      }
      let formatted_date = format(event, "yyyy-MM-dd");
      this.current_customizing_availability_date = event;
      this.current_customizing_availability_date_formatted = formatted_date;
      this.show_edit_date_availability_popup_by_date();
    },
    show_edit_date_availability_popup_by_date() {
      this.show_edit_date_availability_popup = true;
      this.show_edit_date_availability = true;
      this.show_apply_to_multiple_dates = false;
      this.current_date_popup_action_btns_is_enabled = true;
      //console.log(typeof this.current_customizing_availability_date);

      this.current_customizing_availability_date_details = cloneDeep(
        this.service_availability_data.dates_availability[
          this.current_customizing_availability_date_formatted
        ]
      );

      const multiple_dates_picker = this.$refs.multiple_dates_picker;
      multiple_dates_picker?.$refs?.calendar?.move(
        this.current_customizing_availability_date
      );

      this.show_edit_date_availability = true;
      const element = document.querySelector(".vuecal__cell--selected");
      const tooltip = document.querySelector("#edit_date_availability");

      if (this.popup_instance !== null) {
        this.popup_instance.destroy();
        this.popup_instance = null;
      }

      this.reset_popup_edit_availability_form();

      // Pass the button, the tooltip, and some options, and Popper will do the
      // magic positioning for you:
      this.popup_instance = createPopper(element, tooltip, {
        placement: "auto",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 10]
            }
          }
        ]
      });
    },
    show_apply_to_multiple_dates_by_date() {
      this.show_edit_date_availability = false;
      this.show_apply_to_multiple_dates = true;
      if (this.popup_instance) {
        this.popup_instance.update();
      }
    },
    back_to_show_edit_date_availability() {
      this.show_edit_date_availability = true;
      this.show_apply_to_multiple_dates = false;
      if (this.popup_instance) {
        this.popup_instance.update();
      }
    },
    close_edit_date_availability_popup_by_date() {
      this.show_edit_date_availability_popup = false;
    },
    update_customizes_date_availability(do_) {
      //validation pending
      this.current_date_popup_action_btns_is_enabled = false;

      let action_request_data = {};
      if (do_ == "this_day_unavailable") {
        action_request_data["is_available"] = 0;
        action_request_data["apply_to_days_or_dates"] = "dates";
        action_request_data["dates"] = [
          this.current_customizing_availability_date_formatted
        ];
      } else if (do_ == "this_day_available_use_previous_periods") {
        action_request_data["is_available"] = 1;
        action_request_data["use_previous_periods"] = "1";
        action_request_data["apply_to_days_or_dates"] = "dates";
        action_request_data["dates"] = [
          this.current_customizing_availability_date_formatted
        ];
      } else if (do_ == "this_date_only") {
        action_request_data["apply_to_days_or_dates"] = "dates";
        action_request_data["dates"] = [
          this.current_customizing_availability_date_formatted
        ];
      } else if (do_ == "this_day_from_this_date") {
        action_request_data["apply_to_days_or_dates"] = "days";
        action_request_data["day_index_list"] = [
          format(this.current_customizing_availability_date, "i")
        ];
        action_request_data[
          "from_date"
        ] = this.current_customizing_availability_date_formatted;
      } else if (do_ == "apply_to_selected_dates") {
        action_request_data["apply_to_days_or_dates"] = "dates";
        action_request_data["dates"] = map(
          this.popup_edit_availability_form.selected_dates,
          this.format_date
        );
      } else if (do_ == "apply_to_selected_days") {
        action_request_data["apply_to_days_or_dates"] = "days";
        action_request_data[
          "day_index_list"
        ] = this.popup_edit_availability_form.apply_multiple_days;
        action_request_data[
          "from_date"
        ] = this.current_customizing_availability_date_formatted;
      }

      if (
        do_ !== "this_day_unavailable" &&
        do_ !== "this_day_available_use_previous_periods"
      ) {
        action_request_data[
          "is_available"
        ] = this.current_customizing_availability_date_details.is_available;

        if (
          this.current_customizing_availability_date_details.is_available == 1
        ) {
          action_request_data["periods"] = this.clone_deep(
            this.current_customizing_availability_date_details.periods
          );
        }
      }

      let action1 = "customize_service_availability";
      let action2 = "edit_service_availability_by_month";
      let wpcal_request = {};
      wpcal_request[action1] = {
        service_id: this.$route.params.service_id,
        request_data: action_request_data
      };
      wpcal_request[action2] = {
        service_id: this.$route.params.service_id,
        current_month_view: this.current_calendar_month
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          // response = wpcal_clean_and_parse_json_response(response);
          //console.log(response);
          //alert(response.data.status);
          if (response.data[action1]) {
            //console.log(response.data[action1].status);

            this.notify_single_action_result(response.data[action1], {
              success_msg: "Settings saved.",
              validation_errors: {
                //to get feal of normal toast instead of inline
                target: "",
                zindex: "99999"
              }
            });
            if (response.data[action1].status === "success") {
              this.close_edit_date_availability_popup_by_date();
            }
          }
          this.handle_load_service_availability_by_calendar_view_response(
            response
          );
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.current_date_popup_action_btns_is_enabled = true;
        });
    },
    // get_periods_to_prefill_while_marking_available() {
    //   //validation pending
    //   let date = this.current_customizing_availability_date_formatted;
    //   let action = "get_periods_for_prefill_for_marking_available";

    //   let wpcal_request = {};
    //   wpcal_request[action] = {
    //     service_id: this.$route.params.service_id,
    //     date: date
    //   };

    //   let post_data = {
    //     action: "wpcal_process_admin_ajax_request",
    //     wpcal_request: wpcal_request
    //   };

    //
    //   axios
    //     .post(window.wpcal_ajax.ajax_url, post_data)
    //     .then(response => {
    //       // response = wpcal_clean_and_parse_json_response(response);
    //       console.log(response);
    //       //alert(response.data.status);
    //       if (
    //         response.data[action] &&
    //         response.data[action].availability_data
    //       ) {
    //         this.current_customizing_availability_date_details.periods =
    //           response.data[action].availability_data.periods;
    //         this.current_customizing_availability_date_details.is_available =
    //           "1";
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    reset_popup_edit_availability_form() {
      this.popup_edit_availability_form.apply_multiple_dates_days = "dates";
      this.popup_edit_availability_form.apply_multiple_days = [];
      this.popup_edit_availability_form.selected_dates = [];
    },
    log(d) {
      console.log(d);
    },
    format_date(date_obj) {
      return format(date_obj, "yyyy-MM-dd");
    }
  }
};
</script>

<style scoped>
#edit_date_availability .popper_arrow::before {
  background: #b1b6d1;
}

.error_in_popup {
  padding: 200px 20px 0 20px;
  text-align: center;
}
.error_in_popup a {
  font-size: inherit;
}
</style>
<style>
div[data-modal="service_availability_modal"] .vuecal__body {
  margin-bottom: 35px;
}
</style>
